import {DiscountValidity} from '@dms/api/finance';

import {getApiDateString} from 'shared/web';

const DEFAULT_ROUND_TYPE = 'ALGEBRAIC';
const DEFAULT_ROUND_STEP = '0.01';

export const getEmptyDiscountValidity = (validFrom?: Date): DiscountValidity => ({
  roundType: DEFAULT_ROUND_TYPE,
  roundStep: DEFAULT_ROUND_STEP,
  validFrom: getApiDateString(validFrom ?? new Date()),
});
